<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                    
                    <el-button type="warning" :loading="generating" :disabled="generating" @click="generatePayslip()">{{ t('salary.generate') }}</el-button>
                    <el-button
                        type="success"
                        icon="Download"
                        @click="exportPayslips()"
                        >{{ t('salary.export') }}</el-button
                    >
                </template>
                <!-- <template #btns>
                    <el-button
                        type="success"
                        icon="Download"
                        @click="exportData()"
                        >导出数据汇总</el-button
                    >
                    <el-button
                        type="success"
                        icon="Download"
                        @click="mingxiData()"
                        >导出数据明细</el-button
                    >
                </template> -->
            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :loading="state.loading" :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage" @pageChange="pageChange" @limitChange="limitChange">
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['detail'].open(scope.row)">{{ t('common.detail') }}</el-button>
                        <el-button class="opBtn" size="small" type="warning" link
                            @click="openEdit(scope.row)">{{ t('common.edit') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>
        
        <!-- 编辑工资条对话框 -->
        <el-dialog v-model="editDialogVisible" :title="t('salary.editTitle')" width="500" :before-close="handleEditClose">
            <el-form ref="editForm" :model="editFormData" label-width="100px" class="userFrom">
                <el-form-item :label="t('salary.month')">
                    <el-input v-model="editFormData.time" disabled />
                </el-form-item>
                <el-form-item :label="t('salary.name')">
                    <el-input v-model="editFormData.real_name" disabled />
                </el-form-item>
                <el-form-item :label="t('salary.totalEarnings')">
                    <el-input v-model="editFormData.total_earnings" disabled />
                </el-form-item>
                <el-form-item :label="t('salary.allowance')">
                    <el-input v-model="editFormData.allowance_amount" :placeholder="t('salary.allowancePlaceholder')" type="number" />
                </el-form-item>
                <el-form-item :label="t('salary.deduction')">
                    <el-input v-model="editFormData.total_deductions" :placeholder="t('salary.deductionPlaceholder')" type="number" />
                </el-form-item>
                <el-form-item :label="t('salary.remarks')">
                    <el-input v-model="editFormData.remarks" type="textarea" :rows="3" :placeholder="t('salary.remarksPlaceholder')" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="handleEditClose">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="saveEdit">
                        {{ t('common.save') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
        
        <Detail ref="detail" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, toRaw, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ElMessage, ElMessageBox } from "element-plus";
import Detail from "./components/payslip-detail.vue";
import { t } from "@/locale/index.js";

import { exportExcel } from "@/utils/apiBase"
import { PayslipsList, Payslipssave, PayslipsUpdate } from "@/api/attendance/OTDR.js";
import { pageListApi as userListApi } from "@/api/system/personnel";
import { listToMap } from "@/utils/utils";
const myElementRef = ref();
const searchBox = ref();
const detail = ref();


const { locale } = useI18n();

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const generating = ref(false);
const editDialogVisible = ref(false);
const editFormData = ref({
    id: null,
    time: '',
    real_name: '',
    total_earnings: '',
    allowance_amount: '',
    total_deductions: '',
    remarks: ''
})
const getUserList = () => {
    const params = JSON.stringify({
        "page": 1,
        "limit": 9999,
        "keywords": "",
        "role_id": 0
    })
    userListApi(params).then(res => {
        searchData[0].children = res.data.map(i => {
            return { label: i.real_name, value: i.real_name }
        })
        getSearch(searchData)
    })
}


const searchData = reactive([
    { label: "", type: "select", value: "", field: 'real_name', children: [] },
    { label: "", type: "month", value: "", field: 'time' },
    { label: "", type: "select", value: 99, field: 'employment', children: [] },
]);

const buildTableColumns = () => ([
        { prop: "id", show: false, label: "ID" },
        { show: true, type: "index", label: t('table.index'), width: 40 },
        { prop: "time", show: true, label: t('salary.month') },
        { prop: "real_name", show: true, label: t('salary.name') },
        { prop: "employmentText", show: true, label: t('salary.employment'), width: 90 },
        { prop: "total_earnings", show: true, label: t('salary.totalEarnings') },
        { prop: "allowance_amount", show: true, label: t('salary.allowance') },
        { prop: "total_deductions", show: true, label: t('salary.deduction') },
        { prop: "mpf_deduction", show: true, label: t('salary.mpfDeduction') },
        { prop: "income_after_mpf", show: true, label: t('salary.incomeAfterMpf') },
        { prop: "net_pay", show: true, label: t('salary.netPay') },
        { prop: "remarks", show: true, label: t('salary.remarks'), width: 150 },
        { prop: "operation", show: true, label: t('table.operation'), width: 160 },
        { prop: "gotowork", show: true, label: t('salary.clockDays'), width: 40 },
        { prop: "annual_leave_day", show: true, label: t('salary.annualLeaveDays'), width: 56 },
        { prop: "otday", show: true, label: t('salary.otDays'), width: 40 },
        { prop: "ottime", show: true, label: t('salary.otHours'), width: 40 },
        { prop: "zhiday", show: true, label: t('salary.zhiDays'), width: 40 },
        { prop: "zhitime", show: true, label: t('salary.zhiHours'), width: 40 },
        { prop: "tongxiao_day", show: true, label: t('salary.tongxiaoDays'), width: 80 },
        { prop: "riday", show: true, label: t('salary.weekendDays'), width: 40 },
        { prop: "night_shift_day", show: true, label: t('salary.nightShiftDays'), width: 80 },
]);

const applySearchLabels = () => {
    searchData[0].label = t('salary.name');
    searchData[1].label = t('salary.month');
    searchData[2].label = t('salary.employment');
    searchData[2].children = [
        { label: t('common.all'), value: 99 },
        { label: t('status.onJob'), value: 1 },
        { label: t('status.offJob'), value: 0 },
    ];
};

const state = reactive({
	loading: false,
    title: "",
    column: buildTableColumns(),
    offsetHeight: 0,
    tableHeader: [],
    tableData: [],
});

watch(locale, () => {
    applySearchLabels();
    state.column = buildTableColumns();
    tableHeaderFn();
});

const init = () => {
    // const now = new Date();
    //   const year = now.getFullYear();
    //   const month = now.getMonth() + 1; // 月份是从0开始的，所以要加1
    //   let yue=month.toString().padStart(2, '0');

    //   console.log(year+"-"+yue)
    //   console.log(searchData)
    //   searchData[1].value=year+"-"+yue;
    getUserList()
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}


onMounted(() => {
    try {
        applySearchLabels();
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    state.loading = true
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? []
    const employmentVal = toRaw(searchData.filter(i => i.field === 'employment')[0] ?? {}).value
    const employmentData = (employmentVal === 0 || employmentVal === 1) ? employmentVal : 99
    const requestParams = JSON.stringify({
        "real_name": searchData[0].value ?? '',
        "time": timeData ?? '',
        "employment": employmentData === 99 ? 99 : employmentData,
        "page": page.value,
        "limit": limit.value
    })
    PayslipsList(requestParams).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data?.map(item => {
            return {
                ...item,
                employmentText: item.employment === 1 ? t('status.onJob') : item.employment === 0 ? t('status.offJob') : '-',
            }
        }) ?? []
    }).catch(() => {
        ElMessage.error(t('salary.loadFailed'))
    }).finally(() => {
        state.loading = false
    })
};

// 生成工资条（直接使用界面选择的月份和在职状态）
const generatePayslip = async () => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? ''
    if (!timeData) {
        ElMessage.warning(t('salary.selectMonthFirst'))
        return
    }
    const employmentVal = toRaw(searchData.filter(i => i.field === 'employment')[0] ?? {}).value
    const employment = (employmentVal === 0 || employmentVal === 1) ? employmentVal : 99

    try {
        await ElMessageBox.confirm(
            t('salary.generateConfirmBody', { month: timeData }),
            t('salary.generateConfirmTitle'),
            { confirmButtonText: t('salary.generateConfirmOk'), cancelButtonText: t('common.cancel'), type: 'warning' }
        )
    } catch {
        return
    }

    generating.value = true
    const requestParams = JSON.stringify({
        "time": timeData,
        "employment": employment,
    })
    Payslipssave(requestParams).then(res => {
        if (res.code == 200) {
            ElMessage.success(t('salary.generateSuccess'))
            getSearch(searchData)
        } else {
            ElMessage.error(res.msg || t('salary.generateFailed'))
        }
    }).catch(() => {
        ElMessage.error(t('salary.generateFailed'))
    }).finally(() => {
        generating.value = false
    })
};
// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};




// 导出工资条（按当前筛选条件：月份、在职状态）
const exportPayslips = async () => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? ''
    if (!timeData) {
        ElMessage.warning(t('salary.selectMonth'))
        return
    }
    const employmentVal = toRaw(searchData.filter(i => i.field === 'employment')[0] ?? {}).value
    const employment = (employmentVal === 0 || employmentVal === 1) ? employmentVal : 99
    const { ok, msg } = await exportExcel(
        'Excel/payslipsExcel',
        { time: timeData, employment },
        t('salary.exportFileName', { month: timeData })
    )
    if (!ok) {
        ElMessage.error(msg || t('salary.exportFailed'))
    }
}

// 打开编辑对话框
const openEdit = (row) => {
    editFormData.value = {
        id: row.id,
        time: row.time,
        real_name: row.real_name,
        total_earnings: row.total_earnings || '',
        allowance_amount: row.allowance_amount || '',
        total_deductions: row.total_deductions || '',
        remarks: row.remarks || ''
    }
    editDialogVisible.value = true
}

// 关闭编辑对话框
const handleEditClose = () => {
    editDialogVisible.value = false
    editFormData.value = {
        id: null,
        time: '',
        real_name: '',
        total_earnings: '',
        allowance_amount: '',
        total_deductions: '',
        remarks: ''
    }
}

// 保存编辑
const saveEdit = async () => {
    const requestParams = JSON.stringify({
        id: editFormData.value.id,
        allowance_amount: editFormData.value.allowance_amount || '0',
        total_deductions: editFormData.value.total_deductions || '0',
        remarks: editFormData.value.remarks || ''
    })
    
    try {
        const res = await PayslipsUpdate(requestParams)
        if (res.code === 200) {
            ElMessage.success(t('salary.editSuccess'))
            editDialogVisible.value = false
            getSearch(searchData)
        } else {
            ElMessage.error(res.msg || t('salary.editFailed'))
        }
    } catch (error) {
        ElMessage.error(t('salary.editFailed'))
    }
}


</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
